import { Injectable} from '@angular/core';
import { HttpClient,  HttpHeaders} from '@angular/common/http';
import {  Observable, observable} from 'rxjs';
import {  CookieService} from 'ngx-cookie-service';



@Injectable({
  providedIn: 'root'
})
export class SubscribeService {

  public subscribeUrl = "https://b2b-subscribe.clem.mobi";
  public statUrl = "https://api-oauth.clem.mobi";

  constructor(private http: HttpClient, private cookieService: CookieService) { }




  // subscribe b2b
  subscribeB2B(body): Observable<any> {

  let tokenString =  localStorage.getItem('token_offline')
  let token =  JSON.parse(tokenString)  
 
         let httpOptions = {
           headers: new HttpHeaders()
             .set('Authorization', 'Bearer ' +token.access_token)}
             
   return this.http.post<any>(`${this.subscribeUrl}/api/users`, body, httpOptions);
 }


  // stat faq
  statFaq(data): Observable<any> {

    let tokenString =  localStorage.getItem('token_offline')
    let token =  JSON.parse(tokenString)  
   
           let httpOptions = {
             headers: new HttpHeaders()
               .set('Authorization', 'Bearer ' +token.access_token)
               .set('Content-Type', 'application/x-www-form-urlencoded')}
               
     return this.http.post<any>(`${this.statUrl}/clemmobi/faq`, 
     "&url=" + location.host +
     "&driver_id=" + data.driver_id +
     "&username=" + data.username +
     "&community_driver=" + data.community_driver +
     "&ip_adress=" + data.IPv4 +
     "&connection=" + window.navigator.userAgent, httpOptions);
   }



  getFaqs(): Observable<any> {

  let tokenString =  localStorage.getItem('token_offline')
  let token =  JSON.parse(tokenString)  
 
         let httpOptions = {
           headers: new HttpHeaders()
             .set('Authorization', 'Bearer ' +token.access_token)}
             
   return this.http.get<any>(`https://api-sinformer.clem.mobi/api/inform/faqs`, httpOptions);
 }


}
